// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhm_wx bhm_jb bhm_xl bhm_i bhm_j bhm_q bhm_vt bhm_et bhm_so bhm_sp bhm_eg","CommentsButton__icon":"il_b bhm_rz"};